import { FC } from "react"
import { Channel } from "../../../../../types"

interface Props {
  info: Channel
  onSelect?: (id: string) => void
}

const NameCell: FC<Props> = ({ info, onSelect }) => {
  if (onSelect) {
    return (
      <button
        onClick={() => onSelect(info.id)}
        className="text-left text-teal-600 hover:text-teal-700 hover:underline font-medium"
      >
        {info.name}
      </button>
    )
  }

  return <span className="font-medium text-gray-900">{info.name}</span>
}

export default NameCell
